jQuery(function( $ ) {
	'use strict'

	// An object that handles the display of a confirmation modal

    window.ConfirmationModalManager = {

        defaultTitle        : 'Confirm',
        defaultMessage 	    : 'Are you sure?',
        defaultButtonText 	: 'Confirm',

        modal               : $( '#modal-confirmation' ),
        confirmationButton  : $( '#modal-confirmation .btn-confirm' ),

        callback            : null,

        show : function( args ) {
            if ( ! args.title ) {
                args.title = this.defaultTitle;
            }
            if ( ! args.message ) {
                args.message = this.defaultMessage;
            }
            if ( ! args.buttonText ) {
                args.buttonText = this.defaultButtonText;
            }

            if ( args.callback ) {
                this.callback = args.callback;
            }

            this.modal.find( '.modal-title' ).text( args.title );
            this.modal.find( '.message' ).text( args.message );
            this.confirmationButton.text( args.buttonText );

            this.confirmationButton.off( 'click' );

            this.modal.modal();
            this.confirmationButton.focus();

            this.confirmationButton.on( 'click', function() {
                window.ConfirmationModalManager.modal.modal( 'hide' );
                if ( window.ConfirmationModalManager.callback ) {
                    window.ConfirmationModalManager.callback();
                }
            });

        }

    };

});
